import { NgModule } from '@angular/core';
import * as router from '@angular/router';

import { CoreModule } from '@xanadu/core';
import { InputModule } from '@xanadu/input';
import { MetaModule } from '@xanadu/meta';
import { MenuModule } from '@xanadu/menu';
import { ServiceModule } from '@xanadu/service';

import { ViewComponent } from './view/view.component';
import { ContentTreeComponent } from './content-tree/content-tree.component';
import { AspectTreeComponent } from './aspect-tree/aspect-tree.component';
import { BatchTreeComponent } from './batch-tree/batch-tree.component';
import { BatchViewComponent } from './batch-view/batch-view.component';
import { BatchPanelComponent } from './batch-panel/batch-panel.component';
import { SitePanelComponent } from './site-panel/site-panel.component';
import { ContentPanelComponent } from './content-panel/content-panel.component';
import { PrototypePanelComponent } from './prototype-panel/prototype-panel.component';
import { TypePanelComponent } from './type-panel/type-panel.component';
import { ContentViewComponent } from './content-view/content-view.component';
import { LayoutColumnComponent } from './layout-column/layout-column.component';
import { LoginViewComponent } from './login-view/login-view.component';
import { BodyComponent } from './body/body.component';
import { NoticeComponent } from './notice/notice.component';
import { ScreenComponent } from './screen/screen.component';
import { ExpandComponent } from './expand/expand.component';
import { TabComponent } from './tab/tab.component';
import { TreeComponent } from './tree/tree.component';
import { TypeTreeComponent } from './type-tree/type-tree.component';
import { UserTreeComponent } from './user-tree/user-tree.component';
import { TypeViewComponent } from './type-view/type-view.component';
import { FolderPanelComponent } from './folder-panel/folder-panel.component';
import { GenusPanelComponent } from './genus-panel/genus-panel.component';
import { CategoryPanelComponent } from './category-panel/category-panel.component';
import { GroupPanelComponent } from './group-panel/group-panel.component';
import { UserPanelComponent } from './user-panel/user-panel.component';
import { UserViewComponent } from './user-view/user-view.component';
import { RoleTreeComponent } from './role-tree/role-tree.component';
import { RoleViewComponent } from './role-view/role-view.component';
import { RolePanelComponent } from './role-panel/role-panel.component';
import { UnitPanelComponent } from './unit-panel/unit-panel.component';
import { ClientViewComponent } from './client-view/client-view.component';
import { ClientTreeComponent } from './client-tree/client-tree.component';
import { ClientPanelComponent } from './client-panel/client-panel.component';
import { ClubPanelComponent } from './club-panel/club-panel.component';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { PasswordDialogComponent } from './password-dialog/password-dialog.component';
import { SecurityComponent } from './security/security.component';
import { AccessComponent } from './access/access.component';
import { HeadComponent } from './head/head.component';
import { AspectViewComponent } from './aspect-view/aspect-view.component';
import { FactionPanelComponent } from './faction-panel/faction-panel.component';
import { AspectPanelComponent } from './aspect-panel/aspect-panel.component';
import { ImportTreeComponent } from './import-tree/import-tree.component';
import { ImportViewComponent } from './import-view/import-view.component';
import { RealmPanelComponent } from './realm-panel/realm-panel.component';
import { EndpointPanelComponent } from './endpoint-panel/endpoint-panel.component';
import { SyndicatePanelComponent } from './syndicate-panel/syndicate-panel.component';
import { CastPanelComponent } from './cast-panel/cast-panel.component';
import { RequestComponent } from './request/request.component';
import { ImportComponent } from './import/import.component';
import { EndpointComponent } from './endpoint/endpoint.component';
import { CastComponent } from './cast/cast.component';
import { ExpansionComponent } from './expansion/expansion.component';
import { MetaComponent } from './meta/meta.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { RequestBodyComponent } from './request-body/request-body.component';
import { FieldComponent } from './field/field.component';
import { ContentFieldComponent } from './content-field/content-field.component';
import { ContentComponent } from './content/content.component';
import { PreviewComponent } from './preview/preview.component';
import { PublishComponent } from './publish/publish.component';

import { AspectNodeComponent } from './aspect-node/aspect-node.component';
import { BatchNodeComponent } from './batch-node/batch-node.component';
import { ContentNodeComponent } from './content-node/content-node.component';
import { ImportNodeComponent } from './import-node/import-node.component';
import { RoleNodeComponent } from './role-node/role-node.component';
import { TypeNodeComponent } from './type-node/type-node.component';
import { UserNodeComponent } from './user-node/user-node.component';
import { ClientNodeComponent } from './client-node/client-node.component';

@NgModule({
  declarations: [
    LoginViewComponent,
    BodyComponent,
    ViewComponent,
    LayoutColumnComponent,
    ScreenComponent,
    ContentTreeComponent,
    AspectTreeComponent,
    BatchTreeComponent,
    BatchViewComponent,
    BatchPanelComponent,
    SitePanelComponent,
    ContentPanelComponent,
    PrototypePanelComponent,
    TypePanelComponent,
    ContentViewComponent,
    TypeViewComponent,
    NoticeComponent,
    ExpandComponent,
    TabComponent,
    TreeComponent,
    TypeTreeComponent,
    UserTreeComponent,
    FolderPanelComponent,
    GenusPanelComponent,
    CategoryPanelComponent,
    UserViewComponent,
    GroupPanelComponent,
    UserPanelComponent,
    RoleTreeComponent,
    RoleViewComponent,
    RolePanelComponent,
    UnitPanelComponent,
    ClientViewComponent,
    ClientTreeComponent,
    ClientPanelComponent,
    ClubPanelComponent,
    LoginDialogComponent,
    PasswordDialogComponent,
    SecurityComponent,
    AccessComponent,
    ContentComponent,
    PreviewComponent,
    PublishComponent,
    HeadComponent,
    AspectViewComponent,
    FactionPanelComponent,
    AspectPanelComponent,
    ImportTreeComponent,
    ImportViewComponent,
    RealmPanelComponent,
    EndpointPanelComponent,
    SyndicatePanelComponent,
    CastPanelComponent,
    RequestComponent,
    ImportComponent,
    EndpointComponent,
    CastComponent,
    ExpansionComponent,
    MetaComponent,
    GlossaryComponent,
    RequestBodyComponent,
    FieldComponent,
    ContentFieldComponent,

    AspectNodeComponent,
    BatchNodeComponent,
    ContentNodeComponent,
    ImportNodeComponent,
    RoleNodeComponent,
    TypeNodeComponent,
    UserNodeComponent,
    ClientNodeComponent
  ],
  imports: [
    CoreModule,
    router.RouterModule,
    InputModule,
    MetaModule,
    MenuModule,
    ServiceModule
  ],
  exports: [
    LoginViewComponent,
    ViewComponent,
    BodyComponent,
    HeadComponent,
    NoticeComponent,
    ScreenComponent
  ],
  providers: []
})
export class ComponentModule { }
export * from './view/view.component';
export * from './login-view/login-view.component';
